import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { appRoute, authedRoute } from '../../router/parents';
import { BookingsPage } from './ops/bookings';
import { CheckinsPage } from './ops/checkins';
import { DashboardPage } from './ops/dashboard';
import { OnboardingPage } from './ops/onboarding';
import { PaymentsPage } from './ops/payments';

/** Onboarding wizard: signed in, outside the app shell (child of authedRoute). */
export const onboardingRoutes: AnyRoute[] = [createRoute({ getParentRoute: () => authedRoute, path: '/onboarding', component: OnboardingPage })];

/** Day-to-day pages inside the app shell (children of appRoute). */
export const opsRoutes: AnyRoute[] = [
  createRoute({ getParentRoute: () => appRoute, path: '/dashboard', component: DashboardPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/bookings', component: BookingsPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/payments', component: PaymentsPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/checkins', component: CheckinsPage }),
];
